<template>
  <div class="form">
    <v-card style="margin-top: 250px">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <h1 align="center" style="text-decoration: underline overline">
          JRG - SEKSYEN 4 : PERALATAN & KEMUDAHAN ISI RUMAH
        </h1>

        <v-text-field
          outlined
          dense
          rounded
          v-model="HID"
          label="HID"
          :rules="rules"
          width="20px"
          disabled
        ></v-text-field>

        <!-- DATATABLE  -->
        <v-card color="rgba(217, 217, 217, 0.5)" class="mb-5">
          <v-card-title>
            Senarai
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="dataJRG"
            :search="search"
            class="ml-3 mr-3"
            @click:row="handleClick"
            :footer-props="{ 'items-per-page-options': [3, 15, 30, 50, 100, -1] }"
          >
          <template v-slot:item.PR1_i= "{ item }">
            {{ formatNumber(item.PR1_i) }}
          </template>
          <!-- <template v-slot:item.KP9= "{ item }">
            {{ testFunction(item.KP9) }}
          </template> -->
          </v-data-table>
        </v-card>
      </v-card>

    <v-card>
       <span style="color:red;font-weight:bold;font-size: small;"><v-col>Medan yang bertanda * wajib diisi</v-col></span>
      <v-card-title>
        <strong>SEKSYEN 4 : PERALATAN DAN KEMUDAHAN ISI RUMAH </strong><br />
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- S181 -->
          <v-row>
            <!-- * Isikan     : Kod 1 (Jika jawapan YA/) Kod (Jika jawapan TIDAK) -->
            <v-col>
              S.1  Bagaimanakah ahli isi rumah anda biasanya bergerak dari
              tempat kediaman ke sesuatu tempat lain? <br /><br />
              <strong>1. Persendirian</strong><br /><br />
              <v-row>
                <v-col cols="3" sm="4" md="5">
                  a. Kereta/ van/ kenderaan pacuan empat roda
                  <strong>[KP1]</strong> <span style="color:red;font-weight:bold;font-size: small;"> * </span>
                  <v-autocomplete
                    :items="yaTidak"
                    :item-text="(item) => item.id + ' - ' + item.desc"
                    item-value="id"
                    label=""
                    return-object
                    solo
                    dense
                    v-model="KP1"
                    min="1"
                    max="2"
                  ></v-autocomplete
                ></v-col>

                <v-col cols="3" sm="4" md="5">
                  b. Motosikal/ Skuter <strong>[KP2]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                  <v-autocomplete
                    :items="yaTidak"
                    :item-text="(item) => item.id + ' - ' + item.desc"
                    item-value="id"
                    label=""
                    return-object
                    solo
                    dense
                    v-model="KP2"
                    min="1"
                    max="2"
                  ></v-autocomplete> </v-col></v-row></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              c. Basikal <strong>[KP3]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
                :items="yaTidak"
                :item-text="(item) => item.id + ' - ' + item.desc"
                item-value="id"
                label=""
                return-object
                solo
                dense
                v-model="KP3"
                min="1"
                max="2"
              ></v-autocomplete
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              d. Bot/ sampan <strong>[KP4]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
                :items="yaTidak"
                :item-text="(item) => item.id + ' - ' + item.desc"
                item-value="id"
                label=""
                return-object
                solo
                dense
                v-model="KP4"
                min="1"
                max="2"
              ></v-autocomplete></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              e. Lori <label class="font-italic">pickup </label>
              <strong>[KP5]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
                :items="yaTidak"
                :item-text="(item) => item.id + ' - ' + item.desc"
                item-value="id"
                label=""
                return-object
                solo
                dense
                v-model="KP5"
                min="1"
                max="2"
              ></v-autocomplete></v-col
          ></v-row>

          <strong>2. Awam</strong><br /><br />
          <v-row>
            <v-col cols="3" sm="4" md="5">
              a. Keretapi (termasuk komuter, LRT, monorel dan ERL)
              <strong>[KP6]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
                :items="yaTidak"
                :item-text="(item) => item.id + ' - ' + item.desc"
                item-value="id"
                label=""
                return-object
                solo
                dense
                v-model="KP6"
                min="1"
                max="2"
              ></v-autocomplete
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              b. Bas <strong>[KP7]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
                :items="yaTidak"
                :item-text="(item) => item.id + ' - ' + item.desc"
                item-value="id"
                label=""
                return-object
                solo
                dense
                v-model="KP7"
                min="1"
                max="2"
              ></v-autocomplete></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              c. Feri/ bot/ sampan <strong>[KP8]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
                :items="yaTidak"
                :item-text="(item) => item.id + ' - ' + item.desc"
                item-value="id"
                label=""
                return-object
                solo
                dense
                v-model="KP8"
                min="1"
                max="2"
              ></v-autocomplete
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              d. Teksi/ kereta sewa/ beca <strong>[KP9]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
                :items="yaTidak"
                :item-text="(item) => item.id + ' - ' + item.desc"
                item-value="id"
                label=""
                return-object
                solo
                dense
                v-model="KP9"
                min="1"
                max="2"
              ></v-autocomplete></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              e. <label class="font-italic">e-hailing </label> (cth :
              <label class="font-italic"> Grab, MyCar </label> )
              <strong>[KP10]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
                :items="yaTidak"
                :item-text="(item) => item.id + ' - ' + item.desc"
                item-value="id"
                label=""
                return-object
                solo
                dense
                v-model="KP10"
                min="1"
                max="2"
              ></v-autocomplete
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              3. Tiada (contoh : berjalan kaki) <strong>[KP11]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
                :items="yaTidak"
                :item-text="(item) => item.id + ' - ' + item.desc"
                item-value="id"
                label=""
                return-object
                solo
                dense
                v-model="KP11"
                min="1"
                max="2"
              ></v-autocomplete></v-col
          ></v-row>

          S.2  Nyatakan bilangan sekiranya isi rumah anda mempunyai peralatan/
          kemudahan berikut :<br /><br />
          <strong>Peralatan Tempat Kediaman</strong><br /><br />
          <v-row>
            <v-col cols="3" sm="4" md="5">
              1. Kereta <strong>[PR1]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR1"
                label=""
                required
                min="0"
                :rules="[rules.Keretalength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <!-- Sekiranya ada pengisian di S182 (1), maka S182(i) perlu ada pengisian -->
            <v-col cols="3" sm="4" md="5" v-show="showS182i">
              1(i). Jumlah anggaran harga semasa semua kereta yang dimiliki
              <strong>[PR1_i]</strong><br />
              <v-text-field
                outlined
                dense
                v-model="PR1_i"
                label="RM"
                required
                min="0"
                :rules="[rules.KeretaRM]"
                maxlength="8"
                 type="number"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              2. Motosikal/ skuter <strong>[PR2]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR2"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              3. Basikal <strong>[PR3]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR3"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              4. Alat penghawa dingin <strong>[PR4]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR4"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              5. Mesin basuh <strong>[PR5]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR5"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              6. Peti sejuk <strong>[PR6]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR6"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              7. Dapur gas memasak/ Gas Petroleum Cecair (LPG)/ Gas Asli Cecair
              (LNG) <strong>[PR7]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR7"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              8. Dapur solar <strong>[PR8]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR8"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              9. Dapur elektrik <strong>[PR9]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR9"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              10. Dapur minyak tanah <strong>[PR10]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR10"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              11. Dapur kayu/ arang <strong>[PR11]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR11"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              12. Ketuhar gelombang mikro <strong>[PR12]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR12"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              13. Penapis air <strong>[PR13]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR13"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              14. Penapis udara <strong>[PR14]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR14"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <strong>Kemudahan Komunikasi</strong><br /><br />
          <v-row>
            <v-col cols="3" sm="4" md="5">
              15. Pemain video/VCD/DVD/PSP/KONSOL permainan <strong>[PR15]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR15"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              16. Kamera/ video digital <strong>[PR16]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR16"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              17. Komputer peribadi <strong>[PR17]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR17"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              18. Komputer riba <strong>[PR18]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR18"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              19. Papan elektronik mudah alih (cth.:ipad, dll.)
              <strong>[PR19]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR19"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              20. Radio/ Hi-fi <strong>[PR20]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR20"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              21. Televisyen <strong>[PR21]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR21"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              22. Telefon talian tetap <strong>[PR22]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" dark v-bind="attrs" v-on="on">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>
                  * i) Talian telefon yang menyambungkan peralatan terminal
                  pelanggan (contohnya set telefon, mesin faksimili) kepada
                  Rangkaian Telefon Bersuis (PSTN) dan yang mempunyai sebuah
                  port pada pertukaran telefon<br />
                  ii) Istilah ini adalah sinonim dengan stesen istilah utama
                  atau Pertukaran Talian Terus (DEL) yang biasanya digunakan
                  dalam dokumen telekomunikasi. Ia mungkin tidak sama seperti
                  akses dalam talian atau langganan
                </span> </v-tooltip
              ><br />
              <v-text-field
                solo
                dense
                v-model="PR22"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              23. Telefon bimbit biasa <strong>[PR23]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR23"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              24. Telefon bimbit pintar <strong>[PR24]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR24"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              25. Langganan internet tetap <strong>[PR25]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" dark v-bind="attrs" v-on="on">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>
                  * Termasuk unifi, streamyx, Maxis Home Fibre Internet dan Time
                  Fibre Home Broadband
                </span> </v-tooltip
              ><br />
              <v-text-field
                solo
                dense
                v-model="PR25"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              26. Langganan internet mudah alih <strong>[PR26]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR26"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              27. Siaran TV berbayar (cth.: astro, hypptv, dll.)
              <strong>[PR27]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR27"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              28. Langganan perkhidmatan digital (cth.: Netflix, iFlix, Xbox,
              Office365, dll.) <strong>[PR28]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR28"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <strong>Peralatan keselamatan</strong><br /><br />
          <v-row>
            <v-col cols="3" sm="4" md="5">
              29. Kamera litar tertutup <strong>[PR29]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR29"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>

            <v-col cols="3" sm="4" md="5">
              30. Alat penggera kebakaran <strong>[PR30]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR30"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="3" sm="4" md="5">
              31. Alat pemadam kebakaran <strong>[PR31]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-text-field
                solo
                dense
                v-model="PR31"
                label=""
                required
                min="0"
                :rules="[rules.Itemlength]"
                maxlength="2"
                @keypress="isNumber($event)"
              ></v-text-field></v-col></v-row
        ></v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click='simpan()' 
        v-show="butangSimpan" 
        :disabled="!KP1 || !KP2 || !KP3 || !KP4 || !KP5 || !KP6 || !KP7 || !KP8 || !KP9 || !KP10 || !KP11 
        || !PR1 || !PR24">
          Simpan
        </v-btn>
        <v-btn
          text
          color="primary"
          v-show="butangKemaskini"
          @click="updateJRG()"
        >
          Kemaskini
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-alert prominent type="error" :value="popUpALert">
      <v-row align="center" class="mb-2">
        <v-col class="grow"> Adakah anda pasti untuk padam? </v-col>
        <v-col class="shrink">
          <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
          <v-btn @click="padam('2')">Cancel</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" width="500" height="200">
      <v-card>
        <v-alert dense outlined color="#C51162" type="error">
          <strong>{{ errMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>

    <!-- Success Dialog -->
    <v-dialog v-model="successDialog" width="500" height="200">
      <v-card color="success">
        <v-alert dense outlined color="#C51162" type="success">
          <strong>{{ successMessage }}</strong>
        </v-alert>

         <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <v-btn
                color="pink"
                v-show="butangKemaskini"
                @click='successDialog = false;'
            >
              Kemaskini
            </v-btn>
            <v-btn
              color="primary"
              @click='goTo("2")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>

  </div>
</template>
<script>
import axios from "axios";

//////////////////////////import services///////////////////
import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();

import lookupField from "@/services/lookupField";
const lookupFieldServices = new lookupField();

//////////////////////////end import services//////////////

export default {
  async beforeMount() {
    var dataHID = localStorageData.getHIDdata();

    this.HID = dataHID.HID;
    this.BNO = dataHID.BNO;
    this.Ps = dataHID.P;
    this.S = dataHID.S;
    this.NG = dataHID.NG;
    this.DP = dataHID.DP;
    this.DB = dataHID.DB;
    this.BP = dataHID.BP;
    this.ST = dataHID.ST;
    this.NOTK = dataHID.NOTK;
    this.NOIR = dataHID.NOIR;
    this.Bulan = dataHID.BULAN;
    this.Tahun = dataHID.TAHUN;

    this.yaTidak = lookupFieldServices.getYaTidak();
    this.currNOAIRData = localStorageData.getCurrentNOAIRData(); //dapatkan NOAIR yang di click dari page depan
    this.NOAIR = this.currNOAIRData.NOAIR;

    this.getData(); //dapatkan data based on HID
  },
  computed: {
    // dataJRG(){
    //   return this.dataJRG.map(item => ({
    //       ...item,
    //       PR1_i: this.formatNumber(item.PR1_i),
    //     }));
    // },

  },
  data: () => ({
    updateButton: true,
    saveButton: false,
    dialog: false,
    butangSimpan: true,
    butangSeterusnya: false,
    butangKemaskini: false,
    successDialog: false,
    errorDialog: false,
    successMessage: "",
    errMessage: "",
    message: "Saving Data",
    popUpALert: false,
    search: "",
    currNOAIRData: "",
    yaTidak: [],
    S182: false,
    showS182i: false,
    /////////////////////data declaration//////////////////////////

    HID: "",
    // NOAIR: "",
    KP1: "",
    KP2: "",
    KP3: "",
    KP4: "",
    KP5: "",
    KP6: "",
    KP7: "",
    KP8: "",
    KP9: "",
    KP10: "",
    KP11: "",
    PR1: 0,
    PR1_i: 0,
    PR2: 0,
    PR3: 0,
    PR4: 0,
    PR5: 0,
    PR6: 0,
    PR7: 0,
    PR8: 0,
    PR9: 0,
    PR10: 0,
    PR11: 0,
    PR12: 0,
    PR13: 0,
    PR14: 0,
    PR15: 0,
    PR16: 0,
    PR17: 0,
    PR18: 0,
    PR19: 0,
    PR20: 0,
    PR21: 0,
    PR22: 0,
    PR23: 0,
    PR24: 0,
    PR25: 0,
    PR26: 0,
    PR27: 0,
    PR28: 0,
    PR29: 0,
    PR30: 0,
    PR31: 0,
    dataJRG: [],

    headers: [
      {
        // text: "NOAIR",
        align: "start",
        sortable: false,
        // value: "NOAIR",
      },

      { text: "HID", value: "HID" },
      { text: "KP1", value: "KP1" },
      { text: "KP2", value: "KP2" },
      { text: "KP3", value: "KP3" },
      { text: "KP4", value: "KP4" },
      { text: "KP5", value: "KP5" },
      { text: "KP6", value: "KP6" },
      { text: "KP7", value: "KP7" },
      { text: "KP8", value: "KP8" },
      { text: "KP9", value: "KP9" },
      { text: "KP10", value: "KP10" },
      { text: "KP11", value: "KP11" },
      { text: "PR1", value: "PR1" },
      { text: "PR1_i", value: "PR1_i" },
      { text: "PR2", value: "PR2" },
      { text: "PR3", value: "PR3" },
      { text: "PR4", value: "PR4" },
      { text: "PR5", value: "PR5" },
      { text: "PR6", value: "PR6" },
      { text: "PR7", value: "PR7" },
      { text: "PR8", value: "PR8" },
      { text: "PR9", value: "PR9" },
      { text: "PR10", value: "PR10" },
      { text: "PR11", value: "PR11" },
      { text: "PR12", value: "PR12" },
      { text: "PR13", value: "PR13" },
      { text: "PR14", value: "PR14" },
      { text: "PR15", value: "PR15" },
      { text: "PR16", value: "PR16" },
      { text: "PR17", value: "PR17" },
      { text: "PR18", value: "PR18" },
      { text: "PR19", value: "PR19" },
      { text: "PR20", value: "PR20" },
      { text: "PR21", value: "PR21" },
      { text: "PR22", value: "PR22" },
      { text: "PR23", value: "PR23" },
      { text: "PR24", value: "PR24" },
      { text: "PR25", value: "PR25" },
      { text: "PR26", value: "PR26" },
      { text: "PR27", value: "PR27" },
      { text: "PR28", value: "PR28" },
      { text: "PR29", value: "PR29" },
      { text: "PR30", value: "PR30" },
      { text: "PR31", value: "PR31" },
    ],
    ///////////link untuk ke page/////////////////////
    
      breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
      {
        text: "JRG",
        disabled: true,
        href: "JRG",
      },
    ],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    rules: {
      Keretalength: (value) => {
        return value <= 15 || "(Hanya nilai 0-15 sahaja)";
      },
      KeretaRM: (value) => {
        return value <= 99999999 || "(Hanya nilai 0-99999999 sahaja)";
      },
      Itemlength: (value) => {
        return value <= 15 || "(Hanya nilai 0-15 sahaja)";
      },
      required: (v) => !!v || "field is required",
      emel: (value) => {
        return /.+@.+\..+/.test(value) || "E-mail must be valid";
      },
      percentage: (value) => {
        return value <= 100 || "Percentage must between 1 - 100";
      },
      takmauPoint: (value) => {
        return value % 1 === 0 ? true : "No point needed";
      },
    },
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
  }),

  methods: {
    isNumber($event) {
    //console.log($event.keyCode); //keyCodes value
    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      // 46 is dot
      $event.preventDefault();
    // } else {
    //   this.showS182i = true;
      }
    },
    // formatNumber(value) {
    //  console.log(value)
    //  if (value === null || value === 0) {
    //       value = '0'; 
    //   } else if (typeof value !== 'string') {
    //       value = String(value); // Convert non-string values to string
    //   }
    //   // Check if value is empty or not
    //   if (value.trim() === '') {
    //       return '';
    //   }
    //   // Perform the replace operation to format the number with commas
    //   return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //   },
    // testFunction(value){
    //   if (value == 1){
    //     return "YA"
    //   }else{
    //     return "TIDAK"
    //   }
    // },
    formatNumber(value) {
    // Treat 0 as a special case to display 0 in the data table
        if (value === 0) {
            return '0';
        } else if (value === null) {
            return ''; // Treat null values as empty strings for consistency
        } else if (typeof value !== 'string') {
            value = String(value); // Convert non-string values to string
        }
        // Check if value is empty or not
        if (value.trim() === '') {
            return '';
        }
        // Perform the replace operation to format the number with commas
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    // stripCommas(value) {
    //   return value.replace(/,/g, '');
    // },
    stripCommas(value) {
    // Check if value is a string before replacing commas
    if (typeof value !== 'string') {
        return value; // Return value unchanged if it's not a string
    }
    return value.replace(/,/g, '');
    },

    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },

    async simpan() {
      if (this.$refs.form.validate()) {
        this.dialog = true;
        setTimeout(() => (this.dialog = false), 2000);
        console.log(this.PR1_i);

        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/JR5/JRG`,
            {
              HID: this.HID,
              // NOAIR: this.NOAIR,
              KP1: this.KP1.id,
              KP2: this.KP2.id,
              KP3: this.KP3.id,
              KP4: this.KP4.id,
              KP5: this.KP5.id,
              KP6: this.KP6.id,
              KP7: this.KP7.id,
              KP8: this.KP8.id,
              KP9: this.KP9.id,
              KP10: this.KP10.id,
              KP11: this.KP11.id,
              PR1: this.PR1,
              PR1_i: this.PR1_i === null ? '0' : this.stripCommas(this.PR1_i),
              PR2: this.PR2,
              PR3: this.PR3,
              PR4: this.PR4,
              PR5: this.PR5,
              PR6: this.PR6,
              PR7: this.PR7,
              PR8: this.PR8,
              PR9: this.PR9,
              PR10: this.PR10,
              PR11: this.PR11,
              PR12: this.PR12,
              PR13: this.PR13,
              PR14: this.PR14,
              PR15: this.PR15,
              PR16: this.PR16,
              PR17: this.PR17,
              PR18: this.PR18,
              PR19: this.PR19,
              PR20: this.PR20,
              PR21: this.PR21,
              PR22: this.PR22,
              PR23: this.PR23,
              PR24: this.PR24,
              PR25: this.PR25,
              PR26: this.PR26,
              PR27: this.PR27,
              PR28: this.PR28,
              PR29: this.PR29,
              PR30: this.PR30,
              PR31: this.PR31,
            }
          );
            this.res = res.data;
          this.successDialog = true;
          // setTimeout(() => (this.successDialog = false), 2000);
          this.successMessage = "Data Disimpan!";
          this.reset();
          this.getData();
          // setTimeout(() => this.goTo(), 1000);
                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
        }
      } else {
        window.scrollTo(0, 0);
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "Please fill in the field!";
      }
    },
    async updateJRG() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/JR5/updateJRG`,
          {
            HID: this.HID,
            // NOAIR: this.NOAIR,
            KP1: this.KP1.id,
            KP2: this.KP2.id,
            KP3: this.KP3.id,
            KP4: this.KP4.id,
            KP5: this.KP5.id,
            KP6: this.KP6.id,
            KP7: this.KP7.id,
            KP8: this.KP8.id,
            KP9: this.KP9.id,
            KP10: this.KP10.id,
            KP11: this.KP11.id,
            PR1: this.PR1,
            PR1_i: this.PR1_i,
            PR2: this.PR2,
            PR3: this.PR3,
            PR4: this.PR4,
            PR5: this.PR5,
            PR6: this.PR6,
            PR7: this.PR7,
            PR8: this.PR8,
            PR9: this.PR9,
            PR10: this.PR10,
            PR11: this.PR11,
            PR12: this.PR12,
            PR13: this.PR13,
            PR14: this.PR14,
            PR15: this.PR15,
            PR16: this.PR16,
            PR17: this.PR17,
            PR18: this.PR18,
            PR19: this.PR19,
            PR20: this.PR20,
            PR21: this.PR21,
            PR22: this.PR22,
            PR23: this.PR23,
            PR24: this.PR24,
            PR25: this.PR25,
            PR26: this.PR26,
            PR27: this.PR27,
            PR28: this.PR28,
            PR29: this.PR29,
            PR30: this.PR30,
            PR31: this.PR31,
          }
        );
        this.res = res.data;
        this.reset();
        this.butangKemaskini = false;
        this.successDialog = true;
        // setTimeout(() => (this.successDialog = false), 2000);
        this.successMessage = "Data Berjaya Dikemaskini!";
        this.getData();
        window.scrollTo(0, 0);
        //setTimeout(() => (this.goTo()), 1000);
      } catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "Simpan : " + error;
      }
    },
    async padam(val) {
      if (val == 0) {
        this.popUpALert = true;
      } else if (val == 1) {
        try {
          ///////////tunjukkan alert padam////////////
          this.popUpALert = false;
          ////send delete to API///////
          if (this.$refs.form.validate()) {
            const res = await axios.post(
              `${process.env.VUE_APP_API_URL}/JRG/JRG/delete`,
              {
                HID: this.HID,
                // NOAIR: this.NOAIR,
              }
            );
            this.res = res.data;
            this.successDialog = true;
            setTimeout(() => (this.successDialog = false), 2000);
            this.successMessage = "Data Deleted!";
            this.saveButton = false;
            this.updateButton = true;
            this.reset();
            this.getData();
          } else {
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = "Please Fill In the field";
          }
        } catch (error) {
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Padam : " + error;
        }
      } else if (val == 2) {
        this.popUpALert = false;
      }
    },
    async getData() {
      //dapatkan data dari table JRG based on HID
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/JR5/JRG?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {}
        )
        var dataz = res.data.data;
        this.dataJRG = dataz;
        //console.log(res)
      } catch (error) {
        //console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },
    handleClick(row) {
      console.log('Row clicked:', row);
      this.successDialog = true;
      this.successMessage = "Sila mulakan pengemaskinian!";
      // setTimeout(() => (this.successDialog = false), 1000);

      this.butangSimpan = false;
      this.butangKemaskini = true;

      this.HID = row.HID;
      // this.NOAIR = row.NOAIR;
      // this.KP1 = row.KP1;
      // this.KP2 = row.KP2;
      // this.KP3 = row.KP3;
      // this.KP4 = row.KP4;
      // this.KP5 = row.KP5;
      // this.KP6 = row.KP6;
      // this.KP7 = row.KP7;
      // this.KP8 = row.KP8;
      // this.KP9 = row.KP9;
      // this.KP10 = row.KP10;
      // this.KP11 = row.KP11;
      this.PR1 = row.PR1;
      this.PR1_i = this.stripCommas(row.PR1_i);
      this.PR2 = row.PR2;
      this.PR3 = row.PR3;
      this.PR4 = row.PR4;
      this.PR5 = row.PR5;
      this.PR6 = row.PR6;
      this.PR7 = row.PR7;
      this.PR8 = row.PR8;
      this.PR9 = row.PR9;
      this.PR10 = row.PR10;
      this.PR11 = row.PR11;
      this.PR12 = row.PR12;
      this.PR13 = row.PR13;
      this.PR14 = row.PR14;
      this.PR15 = row.PR15;
      this.PR16 = row.PR16;
      this.PR17 = row.PR17;
      this.PR18 = row.PR18;
      this.PR19 = row.PR19;
      this.PR20 = row.PR20;
      this.PR21 = row.PR21;
      this.PR22 = row.PR22;
      this.PR23 = row.PR23;
      this.PR24 = row.PR24;
      this.PR25 = row.PR25;
      this.PR26 = row.PR26;
      this.PR27 = row.PR27;
      this.PR28 = row.PR28;
      this.PR29 = row.PR29;
      this.PR30 = row.PR30;
      this.PR31 = row.PR31;

      // or just do something with your current clicked row item data
      console.log(row);

      // ----------------------------------------------------------------
      if (row.KP1 == 1) {
        this.KP1 = this.yaTidak[0];
      }
      if (row.KP1 == 2) {
        this.KP1 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP2 == 1) {
        this.KP2 = this.yaTidak[0];
      }
      if (row.KP2 == 2) {
        this.KP2 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP3 == 1) {
        this.KP3 = this.yaTidak[0];
      }
      if (row.KP3 == 2) {
        this.KP3 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP4 == 1) {
        this.KP4 = this.yaTidak[0];
      }
      if (row.KP4 == 2) {
        this.KP4 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP5 == 1) {
        this.KP5 = this.yaTidak[0];
      }
      if (row.KP5 == 2) {
        this.KP5 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP6 == 1) {
        this.KP6 = this.yaTidak[0];
      }
      if (row.KP6 == 2) {
        this.KP6 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP7 == 1) {
        this.KP7 = this.yaTidak[0];
      }
      if (row.KP7 == 2) {
        this.KP7 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP8 == 1) {
        this.KP8 = this.yaTidak[0];
      }
      if (row.KP8 == 2) {
        this.KP8 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP8 == 1) {
        this.KP8 = this.yaTidak[0];
      }
      if (row.KP8 == 2) {
        this.KP8 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP9 == 1) {
        this.KP9 = this.yaTidak[0];
      }
      if (row.KP9 == 2) {
        this.KP9 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP10 == 1) {
        this.KP10 = this.yaTidak[0];
      }
      if (row.KP10 == 2) {
        this.KP10 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
      if (row.KP11 == 1) {
        this.KP11 = this.yaTidak[0];
      }
      if (row.KP11 == 2) {
        this.KP11 = this.yaTidak[1];
      }
      //---------------------------------------------------------------
    },
    goTo(option) {
       if(option == "1"){
        this.$router.push({name: "ringkasanMaklumatIR"});
      } 
       if(option == "2"){
        this.$router.push({ name: "JRH" });
       
      }
    }
  },

  
  watch: {
    PR1(val) {
      if (this.PR1 >= 1) {
        this.showS182i = true;
      } else {
        this.showS182i = false;
        this.PR1_i = 0;
      }
    },
  },
};
</script>

<style>
#app {
  background: url("~@/assets/HIES.jpg") no-repeat center center fixed !important;
  background-size: cover;
}
</style>